import React, { FC } from "react";
import { StarScore } from "../StarScore";
import { useResultSearchQuery } from "./category/ApiRequests";
import { SearchProduct } from "./category/Types";

import styles from "./SearchedProducts.module.css";

const AdditionalProducts: FC<{
	products?: SearchProduct[];
	groupName: string;
}> = ({ products, groupName }) => {
	if (!products) {
		return null;
	}

	return (
		<div className={styles.searchProducts}>
			<span>{groupName}</span>
			<ul>
				{products.map((product) => {
					return (
						<li key={product.id}>
							<a href={"/product/" + product.id}>
								<div className={styles.product}>
									<img
										src={product.imgSrc}
										alt="product"
									></img>
									<div>
										<span className={styles.productTitle}>
											{product.name}
										</span>
										<div className={styles.score}>
											<StarScore
												score={product.score}
												starCount={10}
											/>
										</div>
										<span>{product.price} pln</span>
									</div>
								</div>
							</a>
						</li>
					);
				})}
			</ul>
		</div>
	);
};

export const SearchedProducts: FC<{ search: string; callback: () => void }> = ({
	search,
	callback,
}) => {
	const searchResultQuery = useResultSearchQuery(search);

	if (searchResultQuery.isLoading) {
		return <span>Loading...</span>;
	}

	if (searchResultQuery.isError) {
		return <span>Error: {searchResultQuery.error.message}</span>;
	}

	const searchResult = searchResultQuery.data;

	return (
		<div className={styles.searchResults} onMouseLeave={callback}>
			<ul>
				{searchResult.productSearchResult.map((product) => {
					return (
						<li key={product.id + product.name}>
							<a href={`/product/${product.id}`}>
								{product.name}
								<span>{product.price} pln</span>
							</a>
						</li>
					);
				})}
			</ul>
			{searchResult.lastSeenProducts ? (
				<AdditionalProducts
					groupName="Last Seen"
					products={searchResult.lastSeenProducts}
				/>
			) : (
				<AdditionalProducts
					groupName="Recomended Products"
					products={searchResult.recomendedProducts}
				/>
			)}
		</div>
	);
};
